// extracted by mini-css-extract-plugin
export default {"poItems":"ReportDetail_poItems__RqLa-","item":"ReportDetail_item__GVmYg"};